/**
 * A VERSÃO DAS TELAS EM USO neste aparelho (20/10/2026): a do pacote que o atualizador aplicou, ou "builtin" (as que
 * vieram dentro do aplicativo — reconhecidas pelo `id`, não pela versão). Uma pergunta só, usada pela consulta ao servidor (`AtualizadorDeTelas`, que a manda em
 * `?telas=` para a linha de log) e pela linha de Minha conta (`CanalDasTelas`). Sem o plugin (aplicativo antigo) ou fora
 * do aplicativo: "builtin".
 */
export async function versaoDasTelasEmUso(): Promise<string> {
  try {
    const { CapacitorUpdater } = await import('@capgo/capacitor-updater');
    const atual = await CapacitorUpdater.current();
    // As telas que vêm DENTRO do aplicativo têm `id: "builtin"` e, como versão, a do aplicativo ("1.4") — não "builtin"
    // (`CapgoUpdater.getBundleInfo`, no plugin). Pela versão, o "1.4" passava por pacote e saía "fora da forma" no log.
    return versaoDoPacote(atual.bundle);
  } catch {
    return 'builtin';
  }
}

/** A conta, pura (testada em `backend/testes-cruzados/canalDoAparelho.test.ts`): `builtin` pelo `id`, nunca pela versão. */
export function versaoDoPacote(bundle: { id?: string; version?: string } | null | undefined): string {
  if (!bundle || bundle.id === 'builtin') return 'builtin';
  return bundle.version || 'builtin';
}
